import React from 'react';
import PropTypes from 'prop-types';

export default class SystemErrorMessage extends React.Component {

    render() {
        return (
            <div className="alert alert--outline alert--error margin--10--bot">
                {(typeof this.props.notified === 'undefined' || this.props.notified) &&
                    <span>Sorry, there was an error. IT Support have been notified. Reason: </span>
                }
                {this.props.message}
            </div>
        )
    }
}

SystemErrorMessage.propTypes = {
    message: PropTypes.string.isRequired,
};
